
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Emit } from "vue-property-decorator";
import { Action, State } from "vuex-class";

@Component({})
export default class ModalThankYou extends Vue {
  /* PROP */

  @Prop({ default: false })
  private isShow: boolean;

  /* INITIALIZATION */

  constructor() {
    super();
  }

  private onClickOke() {
    this.$emit("update:isShow", false);
    window.location.href = "https://www.career.support/id/edu/";
    localStorage.clear();
  }
}
